import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import { Button } from 'components/Form'

const InputControlsUI = ({
  id,
  type,
  className,
  label,
  labelLeft,
  value,
  onChange,
  color,
  loading,
  disabled,
  isOpenDisabledModal,
  toggleDisabledModal,
  disabledMessage
}) => (
  <div
    className={`
      input-controls
      ${className ? className : ''}
      ${loading ? 'input-controls--loading' : ''}
      ${disabled ? 'input-controls--disabled' : ''}
      ${disabled && !disabledMessage ? 'input-controls--disabled-cursor' : ''}
    `}
  >
    {labelLeft && (
      <strong
        className='input-controls__label'
        dangerouslySetInnerHTML={{ __html: I18n.t(labelLeft) }}
      ></strong>
    )}
    <input
      id={`input-controls-${id}`}
      type='checkbox'
      checked={type === 'checkbox-multiple'
        ? value === 'checked' ? true : false
        : value
      }
      onChange={event => {
        const value = event.target.checked
        onChange({
          value: type === 'checkbox-multiple'
            ? value ? 'checked' : 'none'
            : value
        })
      }}
    />
    {['checkbox', 'checkbox-multiple'].includes(type) && (
      <label
        htmlFor={`input-controls-${id}`}
        className={`
          input-controls__checkbox
          ${color ? `input-controls__checkbox--${color}` : 'input-controls__checkbox--primary'}
        `}
      >
        {value === 'some' ? (
          <i className='fa fa-minus' aria-hidden='true'></i>
        ) : (
          <i className='fa fa-check' aria-hidden='true'></i>
        )}
      </label>
    )}
    {type === 'switch' && (
      <label htmlFor={`input-controls-${id}`} className={`input-controls__switch ${color ? `input-controls__switch--${color}` : 'input-controls__switch--primary'}`}></label>
    )}
    {label && (
      <strong className='input-controls__label' dangerouslySetInnerHTML={{ __html: I18n.t(label) }}></strong>
    )}
    <ModalWrapper
      id='disabledModal'
      isOpen={isOpenDisabledModal}
      toggle={toggleDisabledModal}
      body={
        <p dangerouslySetInnerHTML={{ __html: disabledMessage }}></p>
      }
      footer={
        <div className='button-modal-wrapper'>
          <Button
            secondary
            value={I18n.t('dashboard_accept')}
            onClick={toggleDisabledModal}
          />
        </div>
      }
    />
  </div>
)

export default InputControlsUI
